export interface HttpOptions {
  headers?: Record<string, string | string[]>;
  params?: Record<string, string | string[]>;
  responseType?: 'json' | 'text' | 'blob' | 'arraybuffer';
  withCredentials?: boolean;
}
